import component from './NullStateMessage'

export default component
